// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App' 

// Router
import router from './router/index'

// Vuex
import vuexBasic from './vuex/basic'

// Axios
import $ixios from './shared/ixios-instance.js'


/* Use */
Vue.use(Vuex)
Vue.use(BootstrapVue)

/* Vuex store */
const store = new Vuex.Store({
  modules: {
    basic: vuexBasic
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
